import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Layout from "./components/Layout";
import AdminLayout from "./components/admin/Layout";
import Dashboard from "./components/dashboard/Dashboard";
import Profile from "./components/dashboard/Profile";
import Transactions from "./components/dashboard/Transactions";
import Login from "./components/public/Login";
import Signup from "./components/public/Signup";
import LandingPage from "./components/public/LandingPage";
import Settings from "./components/dashboard/Settings";
import MyReferrals from "./components/dashboard/MyReferrals";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./components/public/ForgotPassword";
import ResetPassword from "./components/public/ResetPassword";
import Support from "./components/dashboard/Support";
import { CryptoProvider } from "./contexts/CryptoContext";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import theme from "./theme";
// Import admin components
import AdminDashboard from "./components/admin/Dashboard";
import UserManagement from "./components/admin/UserManagement";
import TransactionManagement from "./components/admin/TransactionManagement";
import BankManagement from "./components/admin/BankManagement";
import CryptoManagement from "./components/admin/CryptoManagement";
import NotificationManagement from "./components/admin/NotificationManagement";
import SupportManagement from "./components/admin/SupportManagement";
import BankTransfer from "./components/BankTransfer";
import RewardSettings from "./components/admin/RewardSettings";
import SolarDashboard from "./components/solar/SolarDashboard";
import AdminSolarDashboard from "./components/admin/AdminSolarDashboard";
// Add these imports
import SolarTransactionHistory from "./components/solar/SolarTransactionHistory";
import SolarReferrals from "./components/solar/SolarReferrals";
import BankTransactionManagement from "./components/admin/BankTransactionManagement";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CryptoProvider>
        <SnackbarProvider>
          <Router>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPassword />}
              />

              {/* Protected User Routes */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Dashboard />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Profile />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transactions"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Transactions />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Settings />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/referrals"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <MyReferrals />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/support"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Support />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/deposit/bank-transfer"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <BankTransfer />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              {/* Add Solar Dashboard Route */}
              <Route
                path="/solar"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <SolarDashboard />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/solar/transactions"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <SolarTransactionHistory />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/solar/referrals"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <SolarReferrals />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              {/* Protected Admin Routes */}
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <AdminLayout>
                      <Routes>
                        <Route path="dashboard" element={<AdminDashboard />} />
                        <Route path="users" element={<UserManagement />} />
                        <Route
                          path="transactions"
                          element={<TransactionManagement />}
                        />
                        <Route
                          path="bank-transactions"
                          element={<BankTransactionManagement />}
                        />
                        <Route path="banks" element={<BankManagement />} />
                        <Route path="crypto" element={<CryptoManagement />} />
                        <Route
                          path="notifications"
                          element={<NotificationManagement />}
                        />
                        <Route path="support" element={<SupportManagement />} />
                        <Route path="rewards" element={<RewardSettings />} />
                        <Route path="solar" element={<AdminSolarDashboard />} />
                      </Routes>
                    </AdminLayout>
                  </ProtectedRoute>
                }
              />

              {/* Catch all route - redirect to landing page */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </SnackbarProvider>
      </CryptoProvider>
    </ThemeProvider>
  );
};

export default App;
